@if (layoutService.breakpoint | async; as breakpoint) {
	<div
		class="nav-drawer"
		[class.hide]="!isNavigationDrawerOpen"
		[class.visible]="isNavigationDrawerOpen"
		[ngClass]="{ 'has-secondary-workspace': applicationState.secondaryWorkspaceEnabled }"
	>
		<button
			[attr.title]="
				isNavigationDrawerOpen
					? ('navigation.workspace.hidedrawer' | translate)
					: ('navigation.workspace.showdrawer' | translate)
			"
			[attr.aria-label]="
				isNavigationDrawerOpen
					? ('navigation.workspace.hidedrawer' | translate)
					: ('navigation.workspace.showdrawer' | translate)
			"
			class="hide-drawer"
			(click)="toggleMenu(breakpoint)"
		>
			<i class="ico ico-chevron-left-small" [ngClass]="{ rotate: !isNavigationDrawerOpen }"></i>
		</button>
		<stages-workspace-navigation></stages-workspace-navigation>
		<div
			class="main-navigation"
			[ngClass]="{
				visible:
					(!applicationState.workspaceNavigationOpen && !applicationState.secondaryWorkspaceNavigationOpen) ||
					(!applicationState.workspaceNavigationOpen && !applicationState.secondaryWorkspaceEnabled),
			}"
		>
			<div class="wrapper">
				<stages-navigation></stages-navigation>
			</div>
		</div>
	</div>
}
<stages-clipboard />
